<template>
    <v-container fluid justify-center>
        <div class="d-flex flex-column pt-1 px-16 mt-2">
            <h1>Projects</h1>
            <p class="project-summary">
                Some of my work
            </p>
        </div>
        <div
            v-if="isFetching" 
            class="py-12 px-10"
        >
            <div
                v-for="project in projects"
                :key="project.title"
                class="d-flex individual-project"
            >
                <div>
                    <router-link :to="'/projects/' + project.link" class="project-link d-flex">
                        <div class="project-details d-flex flex-column">
                            <p class="pt-5 project-title">{{ project.title }}</p>
                            <p class="font-weight-light project-description">{{ project.projectDesc.toUpperCase() }}</p>
                        </div>
                        <v-img :src=project.picture cover />
                    </router-link>
                </div>
            </div>
        </div>
        <div v-else class="py-12 px-10">
            <v-skeleton-loader type="image, article" class="individual-project" />
        </div>
    </v-container>  
</template>
    
<script>
import axios from 'axios';
import store from '../store';
export default {
    name: 'projectPage',  
    title: 'Darcey Grundy | Work',
    data() {
        return {
            storedProjects: store.state.projects.allProjects,
            projects: [],
            isFetching: true,
            hostName: {
                portfolioServer: process.env.VUE_APP_PORTFOLIO_SERVER
            }
        }
    },
    mounted: async function() {
        let $vm = this;
        await axios.get(`${this.hostName.portfolioServer}/api/projects`)
            .then(response => {
                store.state.projects.allProjects = response.data;
                $vm.projects = response.data;
                $vm.isFetching = false;
            })
            .catch(function(error) {
                console.log(error)
            })
    }
}
</script>
    
<style lang="scss" scoped>
div {
    font-family: Gasoek One;
    letter-spacing: 10%;
    color: var(--v-tropicalIndigo-base) !important;
    width: 100%;

    h1 {
        font-size: 40px;

        @media (width > 1000px) {
            font-size: 64px;
        }
    }

    .project-summary {
        font-size: 20px;
    }
}

.individual-project {
    width: 100%;
    transition: transform .3s,box-shadow .3s;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 25px;
    margin: 25px 0;

    @media (width > 1000px) {
        padding: 40px 0;
        border-radius: 0;
        box-shadow: none;
    }

    .project-link {
        flex-direction: column-reverse;
        text-decoration: none;
        font-size: 22px;
        width: 100%;

        @media (width > 1000px) {
            flex-direction: row;
        }

        .project-details {
            padding: 15px;
            height: 50%;

            @media (width > 1000px) {
                padding: 25px;
            }

            .project-title {
                font-size: 20px;
                font-weight: 400;
                color: black;
                letter-spacing: 10%;
                margin-bottom: 5px;
                padding-top: 0 !important;

                @media (width > 1000px) {
                    font-size: 40px;
                    margin-bottom: 20px;
                    letter-spacing: 0%;
                }
            }

            .project-description {
                font-size: 30px;
                font-family: Bebas Neue;
                letter-spacing: 4%;
                line-height: 130%;
                margin: 0;
                color: black;

                @media (width > 1000px) {
                    line-height: 115%;
                }
            }
        }

        .v-image {
            height: 50%;
            border-top-left-radius: 35px;
            border-top-right-radius: 35px;
            
            @media (width > 1000px) {
                height: 400px;
                border-radius: 35px;
            }
        }

        .v-image, .project-details {
            @media (width > 1000px) {
                width: 50%;
            }
        }
    }
}

.individual-project:nth-of-type(odd) .project-link {
    @media (width > 1000px) {
        flex-direction: row-reverse !important;
    }
}

.individual-project:nth-of-type(odd) .project-details {
    @media (width > 1000px) {
        align-items: flex-end;
        text-align: right;
    }
}
</style>